import { create } from "zustand";

/**
 * Кошельки, отмеченные галочкой в панели участников.
 *
 * # Зачем отмечать
 *
 * Ради строки «Итого» над таблицей. Панель отвечает на вопрос «кто набрал» по
 * одному кошельку, а вопрос оператора часто другой: что держит ГРУППА — эти
 * четверо, которых он считает одной рукой. По отдельным строкам такую сумму
 * складывают в уме, и складывают неверно: направления у строк разные, и «+300
 * Up» с «+250 Down» это не «+550».
 *
 * # Почему выбор ПЕРЕЖИВАЕТ смену рынка
 *
 * Потому что группа наблюдения — свойство КОШЕЛЬКОВ, а не окна. Серии
 * пятиминутные, состав участников от окна к окну почти тот же, и сбрасывать
 * отметки на каждом переходе значило бы заставлять оператора собирать группу
 * заново каждые пять минут. Строка «Итого» при этом обязана говорить, скольких
 * из отмеченных в ЭТОМ окне не оказалось: молча сложить четверых из шести —
 * это и есть способ соврать суммой.
 *
 * Тем же и отличается от `openTrades` в панели, которое живёт локально и
 * сбрасывается при смене рынка: раскрытый список сделок — вопрос к КОНКРЕТНОМУ
 * окну, а отметка — к кошельку.
 *
 * # Почему не localStorage
 *
 * Довод соседних сторов. Плюс тот, что группу наблюдения, пережившую сессию,
 * надо уметь ПОКАЗАТЬ, а не только помнить, — и для этого уже есть ручные
 * пометки: они лежат в базе, видны чипами и режут таблицу фильтром.
 */
interface ParticipantPicksStore {
  /** Адреса В НИЖНЕМ РЕГИСТРЕ: источник отдаёт их вперемешку с EIP-55. */
  picked: ReadonlySet<string>;
  has: (wallet: string) => boolean;
  toggle: (wallet: string) => void;
  /**
   * Отметить или снять сразу список — «выбрать все показанные».
   *
   * Не «переключить каждый»: на половине отмеченной таблицы переключение каждой
   * строки дало бы инверсию, а оператор нажимает эту кнопку, чтобы получить
   * определённое состояние.
   */
  setMany: (wallets: readonly string[], on: boolean) => void;
  clear: () => void;
}

export const useParticipantPicks = create<ParticipantPicksStore>((set, get) => ({
  picked: new Set<string>(),
  has: (wallet) => get().picked.has(wallet.toLowerCase()),
  toggle: (wallet) =>
    set((s) => {
      const next = new Set(s.picked);
      const key = wallet.toLowerCase();
      if (!next.delete(key)) next.add(key);
      return { picked: next };
    }),
  setMany: (wallets, on) =>
    set((s) => {
      const next = new Set(s.picked);
      for (const w of wallets) {
        if (on) next.add(w.toLowerCase());
        else next.delete(w.toLowerCase());
      }
      return { picked: next };
    }),
  clear: () => set({ picked: new Set<string>() }),
}));
